import { useDispatch, useSelector } from 'react-redux'

import { goalListRequest } from 'store/modules/goal/actions'
import { GoalWizardNavbar } from 'components/GoalWizard'

const EXIT_PROMPT_KEY = '@NeoPro:CreateGoal-Show-Navbar-Exit-Modal'

const Navbar = ({
  data,
  onBack,
  onBackSave,
  onSave,
  loading,
  canSaveGoal,
  storeId,
  token,
  activeStep
}) => {
  const dispatch = useDispatch()
  const store = useSelector(state => state.store.store)

  const dispatchGoalListRequest = () => {
    dispatch(goalListRequest(storeId, token))
  }

  const handleExit = () => {
    dispatchGoalListRequest()
    onBack()
  }

  const handleExitWithSave = () => {
    dispatchGoalListRequest()
    onBackSave()
  }

  return (
    <GoalWizardNavbar
      title='Cadastrar meta do mês'
      context={store && `| ${store.name}`}
      canSave={Boolean(canSaveGoal && data.month)}
      isSaved={!canSaveGoal}
      loading={loading}
      saveDisabled={
        data == {} || (activeStep === 3 && data.usersWorking.length === 0)
      }
      rememberExitPromptKey={EXIT_PROMPT_KEY}
      exitPrompt={{
        enabled: Boolean(canSaveGoal && data.month),
        title: 'Deseja voltar para o painel?',
        description:
          'Não se preocupe! Todas as informações da meta foram salvas no rascunho. Você pode continuar de onde parou quando quiser.',
        cancelLabel: 'Cancelar',
        confirmLabel: 'Salvar e sair'
      }}
      onLogoClick={onBackSave}
      onSave={onSave}
      onExit={handleExit}
      onExitWithSave={handleExitWithSave}
    />
  )
}

export default Navbar
